module.exports = __webpack_public_path__ + "static/media/liveControl.a7490ff9.png";